/* DTF Gears — xTool O1 Omni page | assets/dtfg-o1-omni.js */
(function(){
function init(root){
  if(!root||root.__dtfo) return; root.__dtfo=true;
  var $$=function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s));};

  /* tabs -> panels (workflows, shop) */
  $$('[data-panels]').forEach(function(box){
    var tabs=$$('[role=tab]',box), panels=$$(':scope > .dtfo-panel',box);
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){
        tabs.forEach(function(x,j){x.setAttribute('aria-selected',j===i);});
        panels.forEach(function(p,j){p.hidden=j!==i;});
      });
    });
  });

  /* carousels */
  function setupCarousel(c){
    var track=c.querySelector('[data-track]'), cnt=c.querySelector('[data-count]');
    function items(){return $$(':scope > *',track).filter(function(e){return !e.hidden;});}
    function update(){
      var it=items(); if(!it.length){cnt.textContent='0 / 0';return;}
      var sl=track.scrollLeft, idx=0, best=1e9;
      it.forEach(function(e,i){var d=Math.abs(e.offsetLeft-track.offsetLeft-sl-parseFloat(getComputedStyle(track).paddingLeft));if(d<best){best=d;idx=i;}});
      if(track.scrollLeft+track.clientWidth>=track.scrollWidth-4) idx=it.length-1;
      cnt.textContent=(idx+1)+' / '+it.length;
    }
    function go(dir){var it=items();if(!it.length)return;var w=it[0].getBoundingClientRect().width+16;track.scrollBy({left:dir*w,behavior:'smooth'});}
    c.querySelector('[data-prev]').addEventListener('click',function(){go(-1);});
    c.querySelector('[data-next]').addEventListener('click',function(){go(1);});
    track.addEventListener('scroll',function(){window.requestAnimationFrame(update);},{passive:true});
    c.__update=update; update();
  }
  $$('[data-carousel]').forEach(setupCarousel);

  /* workflow tabs also filter the gallery */
  $$('[data-wf]').forEach(function(wf){
    var car=wf.closest('section').querySelector('[data-carousel]'); if(!car) return;
    function apply(cat){
      $$('.dtfo-mat',car).forEach(function(m){m.hidden=m.dataset.cat!==cat;});
      car.querySelector('[data-track]').scrollLeft=0; car.__update&&car.__update();
    }
    $$('[data-filter]',wf).forEach(function(t){t.addEventListener('click',function(){apply(t.dataset.filter);});});
    apply('uv');
  });

  /* jump to an edition in the shop */
  var shop=root.querySelector('[data-shop]');
  $$('[data-goto-ed]').forEach(function(a){
    a.addEventListener('click',function(){
      var t=shop&&shop.querySelectorAll('[role=tab]')[+a.dataset.gotoEd]; if(t) t.click();
    });
  });

  /* profit calculator */
  var calc=root.querySelector('[data-calc]');
  if(calc){
    var fmt=function(n){return '$'+n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});};
    var val=function(k){var e=calc.querySelector('[data-c='+k+']');return e?parseFloat(e.value)||0:0;};
    var out=function(k,t){calc.querySelector('[data-o='+k+']').textContent=t;};
    function run(){
      var price=val('price')/100, unit=val('sell')-val('blank')-val('ink'), week=unit*val('qty');
      out('unit',fmt(unit)); out('week',fmt(week));
      if(!price){out('pay','Pick a bundle');return;}
      if(week<=0){out('pay','Adjust your numbers');return;}
      var wk=price/week; out('pay', wk<1?'Under 1 week':(wk<9?Math.ceil(wk)+' weeks':'≈ '+Math.ceil(wk/4.33)+' months'));
    }
    $$('input,select',calc).forEach(function(e){e.addEventListener('input',run);e.addEventListener('change',run);});
    var sel=calc.querySelector('select'); if(sel&&sel.options.length>2) sel.selectedIndex=2;
    run();
  }

  /* add to cart */
  var toast=root.querySelector('[data-toast]'), tt;
  function showToast(html){toast.innerHTML=html;toast.classList.add('show');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('show');},4500);}
  $$('[data-atc]').forEach(function(f){
    f.addEventListener('submit',function(e){
      if(!window.fetch) return;
      e.preventDefault();
      var btn=f.querySelector('button'), txt=btn.textContent; btn.disabled=true; btn.textContent='Adding…';
      var root_url=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(root_url+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:+f.querySelector('[name=id]').value,quantity:1}]})})
      .then(function(r){if(!r.ok) throw r; return r.json();})
      .then(function(){
        btn.textContent='Added ✓';
        showToast('Added to your cart <a href="'+root_url+'cart">View cart →</a>');
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        setTimeout(function(){btn.disabled=false;btn.textContent=txt;},2200);
      })
      .catch(function(){f.submit();});
    });
  });

  /* "what do you sell" matcher */
  var v=root.querySelector('[data-verdict]'), chips=$$('[data-chips] .dtfo-chip');
  function hl(cols){$$('#dtfo-compare [data-col]').forEach(function(c){c.classList.toggle('hl',cols.indexOf(+c.dataset.col)>-1);});}
  function link(u,t){return ' <a href="'+u+'">'+t+' →</a>';}
  function decide(){
    var s={};chips.forEach(function(c){if(c.getAttribute('aria-pressed')==='true')s[c.dataset.k]=1;});
    var app=s.cotton||s.poly, spec=s.fluoro||s.flex, d=v.dataset, h, cols=[];
    if(!Object.keys(s).length){h='<b>Tap what you sell</b> — the right edition lights up in the table.';}
    else if(app&&spec){cols=[2,3];h='<b>No single edition does both.</b> Fluorescent &amp; Flexible White are on the Dual-Head UV; apparel printing is on UV + DT Fabric.'+link(d.uDual,'Dual-Head')+link(d.uFabric,'UV + DT Fabric');}
    else if(app){cols=[3];h='<b>UV + DT Fabric</b> — the only edition with DTG and DTF apparel printing, and it still does UV and UV DTF.'+link(d.uFabric,'See bundles');}
    else if(spec){cols=[2];h='<b>Dual-Head UV</b> — fluorescent red &amp; yellow plus Flexible White for leather and canvas.'+(s.tumbler?' Pick the Professional bundle for the OR1 Rotary.':'')+link(s.tumbler?d.uDualPro:d.uDual,'See bundles');}
    else{cols=[1];h='<b>Single UV</b> covers it — all three editions do this, and Single UV is the most direct fit.'+(s.tumbler?' Pick the Professional bundle for the OR1 Rotary.':'')+link(s.tumbler?d.uSinglePro:d.uSingle,'See bundles');}
    v.innerHTML=h;hl(cols);
  }
  chips.forEach(function(c){c.addEventListener('click',function(){c.setAttribute('aria-pressed',c.getAttribute('aria-pressed')!=='true');decide();});});

  /* sub-nav active link + reveal on scroll */
  if('IntersectionObserver' in window){
    var links=$$('.dtfo-subnav-links a'), map={};
    links.forEach(function(a){var el=root.querySelector(a.getAttribute('href'));if(el)map[el.id]=a;});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting&&map[e.target.id]){links.forEach(function(l){l.classList.remove('on');});map[e.target.id].classList.add('on');}});},{rootMargin:'-40% 0px -55% 0px'});
    Object.keys(map).forEach(function(id){io.observe(root.querySelector('#'+id));});

    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      var rv=$$('.dtfo-h2,.dtfo-feat,.dtfo-ed,.dtfo-acc,.dtfo-card,.dtfo-gal,.dtfo-dark-main,.dtfo-specs,.dtfo-banner-in,.dtfo-choose>div,.dtfo-vs>div,.dtfo-calc');
      rv.forEach(function(e){e.setAttribute('data-rv','');});
      var ro=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');ro.unobserve(e.target);}});},{threshold:.12});
      rv.forEach(function(e){ro.observe(e);});
    }
  }
}
function boot(){document.querySelectorAll('.dtfo').forEach(init);}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.dtfo');if(r)init(r);});
})();